import React from "react";

const fetchJson = async (url, headers) => {
  const res = await fetch(url, { next: { revalidate: 0 }, headers });
  if (!res.ok) throw new Error(`Failed fetch: ${url}`);
  return await res.json();
};

export const getTeamData = async ({ baseUrl, sport, dataId, headers, dataType, leagueId }) => {
  if (sport !== 'football') {

    const teamHead = await fetchJson(
      `${baseUrl}/${sport}/team/${dataId}/header`,
      headers
    );
    return teamHead;


  }
  const leagues = await fetchJson(`${baseUrl}/${sport}/team/${dataId}/leagues`, headers);
  const firstLeagueId = leagues?.data?.[0]?.id;


  switch (dataType) {
    case "team-standings": {
      const standings = await fetchJson(
        `${baseUrl}/${sport}/team/${dataId}/table?leagueId=${firstLeagueId}`,
        headers
      );
      return { league: leagues, standings };
    }

    case "team-squad": {
      const squad = await fetchJson(
        `${baseUrl}/${sport}/stat/team/${dataId}/lineup?leagueId=${firstLeagueId}`,
        headers
      );
      return { league: leagues, squad };
    }

    case "team-stats": {
      const stats = await fetchJson(
        `${baseUrl}/${sport}/stat/team/${dataId}/stats?leagueId=${firstLeagueId}`,
        headers
      );
      return { league: leagues, stats };
    }

    case "team-player-stats": {
      const playerStats = await fetchJson(
        `${baseUrl}/${sport}/stat/team/${dataId}/player-stats?leagueId=${firstLeagueId}`,
        headers
      );
      return { league: leagues, stats: playerStats };
    }

    case "team": {
      const teamHeader = await fetchJson(
        `${baseUrl}/${sport}/team/${dataId}/header?leagueId=${leagueId || firstLeagueId}`,
        headers
      );
      return teamHeader;
    }

    case "team-upcoming": {
      const upcoming = await fetchJson(
        `${baseUrl}/${sport}/team/${dataId}/matches?type=upcoming`,
        headers
      );
      return upcoming;
    }

    case "team-results": {
      const results = await fetchJson(
        `${baseUrl}/${sport}/team/${dataId}/matches?type=finished`,
        headers
      );
      return results;
    }

    case "team-info": {
      const info = await fetchJson(
        `${baseUrl}/${sport}/team/${dataId}/info`,
        headers
      );
      return info;
    }

    case "team-news": {
      const news = await fetchJson(
        `${baseUrl}/${sport}/team/${dataId}/news`,
        headers
      );
      return news;
    }

    default:
      return null;
  }
};
